import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GiftcardImageService {
  private pdfConversionUrl = environment.pdf_conversion_url || 'https://pdf-konv-ociqi7ujdq-lz.a.run.app';

  constructor() { }

  /**
   * Get the image URL for a giftcard by ID
   * @param giftcardId The ID of the giftcard
   * @returns The URL to the giftcard image
   */
  public getGiftcardImageUrl(giftcardId: string): string {
    return `${this.pdfConversionUrl}/convert/${giftcardId}`;
  }

  /**
   * Get the preview URL for a giftcard template
   * @param templateId The template ID for the giftcard
   * @param senderName The name of the sender
   * @param receiverName The name of the receiver
   * @param message Optional message to include
   * @param amount The gift card amount
   * @param venueName The name of the venue
   * @returns The URL to the giftcard preview image
   */
  public getGiftcardPreviewUrl(
    templateId: string,
    senderName: string,
    receiverName: string,
    message: string,
    amount: string | number,
    venueName: string,
    venueId: string | number
  ): string {
    // Build the parameters for the preview
    const params = new URLSearchParams({
      templateId,
      senderName,
      receiverName,
      message,
      amount: amount.toString(),
      venueName,
      venue_id: venueId.toString()
    });
    
    // Return the direct preview URL
    return `${this.pdfConversionUrl}/preview?${params.toString()}`;
  }
}
